module.exports = __webpack_public_path__ + "img/police.cece3129.png";